var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-config-provider',{attrs:{"global-config":_vm.$i18n.messages[_vm.$i18n.locale]}},[_c('div',{class:[
        {
          'win-drag-bar': !_vm.$store.getters.isLogined,
          'browser-wrap': _vm.platform.isBrowser,
          'pc-wrap': _vm.platform.isPC,
          'mobile-wrap': _vm.$store.getters.isMobile || _vm.$store.getters.isMobileStyle,
          wemeet: _vm.$store.getters.isInWeMeetApp,
          winBorder: _vm.$store.getters.isWin,
          'is-login-route': _vm.isLoginRoute && _vm.platform.isBrowser,
        } ],attrs:{"id":"app"}},[_c('router-view',{attrs:{"href":"#"}}),(_vm.platform.isPC)?_c('win-bar'):_vm._e(),(_vm.platform.isPC)?_c('Updater'):_vm._e(),_c('HotkeyDrawer'),(_vm.platform.isPC)?_c('CoSyncFileConflictNotification'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }